export default "__VITE_ASSET__Cxk6Snq9__"